import CustomFormFactory from "../../../../components/CustomFormFactory/CustomFormFactory";
import PageContainer from "../../../../components/PageContainer/PageContainer";
import { getObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import { restUseCase } from "../../../../usecases/rest";
import FormUtils from "../../../../utils/classUtils/FormUtils";
import withRouter from "../../../../utils/withRouter";
import RecordCompanyFormPresenter from "./RecordCompanyFormPresenter";

class RecordCompanyFormPage extends FormUtils {
  constructor(props) {
    super(props);
    this.state = { object: {}, modalState: false };
    this.presenter = new RecordCompanyFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
      restUseCase(),
    );
  }

  getCollectionName() {
    return "records";
  }

  render() {
    const { fields, sections } = this.getSchema(this.getCollectionName());
    const { object } = this.state;

    return (
      <PageContainer title="Create Record">
        <form onSubmit={this.onSubmitForm.bind(this)}>
          <CustomFormFactory
            schema={this.transformFieldsToSections({ fields, sections })}
            object={object}
            fieldsToExlude={[
              ...this.fieldsToExclude,
              "lockedTo",
              "fullName",
              "searchNameId",
              "lockedDate",
              "lockedDateString",
              "rowNum",
              "isScanned",
              "isScannedCSV",
              "isScannedPDF",
              "specificDateLocked",
              "uniquePersonCaseId",
            ]}
            onChange={this.onChange.bind(this)}
            navigateBack={this.navigateBack.bind(this)}
          />
        </form>
      </PageContainer>
    );
  }
}

export default withRouter(RecordCompanyFormPage);
